import React from 'react';
import { useConnect } from '@lore/query-connect';
import { GlobeAltIcon } from '@heroicons/react/24/outline';
import IconSection from '../../../@communityshare/ui/card/IconSection';

export default function Network(props) {
  const { event } = props;

  const network = useConnect('network.byId', {
    id: event.data.networkId
  }, {
    enabled: !!event.data.networkId
  });

  if (!event.data.networkId) {
    return (
      <IconSection
        icon={GlobeAltIcon}
        title="None"
        tooltip="Network"
      />
    );
  }

  return (
    <IconSection
      icon={GlobeAltIcon}
      title={network.data.name || '...'}
      tooltip="Network"
    />
  );
}
